import { render, staticRenderFns } from "./modal_listado_muestras.vue?vue&type=template&id=12fb981c&"
import script from "./modal_listado_muestras.vue?vue&type=script&lang=js&"
export * from "./modal_listado_muestras.vue?vue&type=script&lang=js&"
import style0 from "./modal_listado_muestras.vue?vue&type=style&index=0&id=12fb981c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports